import { Button } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React from 'react';

const IconButton = (props) => {
  const { children, active, onClick, endIcon, ...rest } = props;

  return (
    <Button
      variant='contained'
      endIcon={endIcon}
      onClick={onClick}
      disableElevation
      sx={(theme) => ({
        position: 'relative',
        minWidth: 'auto',
        color: theme.palette.text.secondary,
        padding: '8px 9px',
        height: '100%',
        marginLeft: theme.spacing(1),
        bgcolor: 'background.default',
        span: {
          margin: theme.spacing(0),
        },
        path: {
          fill: theme.palette.text.secondary,
        },
        '&:hover, &.active': {
          bgcolor: 'background.default',
        },
        ...(active && {
          color: theme.palette.primary.main + '!important',
          bgcolor: alpha(theme.palette.primary.main, 0.12) + '!important',
          path: {
            fill: theme.palette.primary.main,
          },
        }),
      })}
      {...rest}>
      {children}
    </Button>
  );
};

export default IconButton;
